import { React, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/admin-theme.css";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";

import { registerNotifications } from "./notificationHelper";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Register notifications on load
registerNotifications();

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
